class BtnFilterFixed {
    constructor(args = { sectionsContainer: document }) {
        this.sectionsContainer = args.sectionsContainer;
        this.sections = this.sectionsContainer.getElementsByClassName("pagination-success-cases");
        if (this.sections[0]) {
            this.init();
        }
    }

    init() {
        Array.from(this.sections).forEach((section) =>
            this.initDesplegables(section)
        );
    }

    initDesplegables(section) {
        const btnFilters = section.querySelector('.btn-fixed');
    
        if (!btnFilters) return;
    
        const onScroll = () => {
            const rect = section.getBoundingClientRect();
            const btnRect = btnFilters.getBoundingClientRect();
    
            if (rect.bottom <= window.innerHeight) {
                btnFilters.classList.add('pos-absol');
            } else {
                btnFilters.classList.remove('pos-absol');
            }
        };
    
        window.addEventListener('scroll', onScroll);
    }


}

export default BtnFilterFixed;
